/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Select from 'react-select'
import Spinner from 'react-bootstrap/Spinner'

interface ItemCreateProps {
	show: boolean;
	handleClose: any;
	id: number;
	idSalesPayments: number;
}

interface PaymentData {
	idSalesPayments: number;
	paymentType: string;
	idSalesOrders: number;
	idSalesInvoice: number;
	idProjects: number;
	idCompanies: number;
	projectName: string;
	remarks: string;
	paymentDate: string;
	paymentMethod: string;
	paymentAmount: number;
	transactionId: string;
	idBanks: number;
	idBankCash: number;
	idSr: number;
	salesType: string;
	invoiceAllocations?: Array<{ idSalesInvoice: number; idSalesOrders: number; paidAmount: number }>;
}

interface InvoiceRow {
	id: number;
	idSalesOrders: number;
	invoiceId: string;
	invoiceAmount: number;
	alreadyPaidAmount: number;
	remainingAmount: number;
	adjustment: number;
	paidAmount: number;
	salesOrderId: string;
	salesOrderDate: string;
}

interface ProjectAmount {
	invoice: number;
	payment: number;
	shipment: number;
}

const initialPaymentData: PaymentData = {
	paymentType: 'advance',
	idSalesOrders: 0,
	idSalesInvoice: 0,
	idProjects: 0,
	idCompanies: 0,
	idBanks: 0,
	idBankCash: 0,
	idSr: 0,
	paymentAmount: 0,
	projectName: '',
	remarks: '',
	paymentDate: '',
	paymentMethod: 'bank_transfer',
	transactionId: '',
	salesType: '',
}

const initialProjectAmount: ProjectAmount = {
	invoice: 0,
	payment: 0,
	shipment: 0
}

const SalesPaymentEdit: React.FC<ItemCreateProps> = ({ show, handleClose, id, idSalesPayments }) => {

	const [maxPayableAmount, setMaxPayableAmount] = useState(0);
	const [paymentType, setPaymentType] = useState('advance');
	const [paymentMethod, setPaymentMethod] = useState('bank_transfer');
	const [projects, setProjects] = useState([]);
	const [project, setProject] = useState({ label: 'Select Project', value: '' });
	const [banks, setBanks] = useState([]);
	const [bank, setBank] = useState({ label: 'Select Bank', value: '' });
	const [mobileWallets, setMobileWallets] = useState([]);
	const [mobileWallet, setMobileWallet] = useState({ label: 'Select Mobile Wallet', value: '' });
	const [cashBoxes, setCashBoxes] = useState([]);
	const [cashBox, setCashBox] = useState({ label: 'Select Cash Box', value: '' });
	const [accounts, setAccounts] = useState([]);
	const [account, setAccount] = useState({ label: 'Select Account Number', value: '' });
	const [chequeAccounts, setChequeAccounts] = useState([]);
	const [chequeAccount, setChequeAccount] = useState({ label: 'Select Account Number', value: '' });
	const [salesOrders, setSalesOrders] = useState([]);
	const [salesOrder, setSalesOrder] = useState({ label: 'Select Sales Order', value: '' });
	const [salesInvoices, setSalesInvoices] = useState([]);
	const [sr, setSr] = useState({ label: 'Select SR', value: '' });
	const [srs, setSrs] = useState([]);
	const [salesInvoice, setSalesInvoice] = useState({ label: 'Select Sales Invoice', value: '' });
	const [companies, setCompanies] = useState([]);
	const [company, setCompany] = useState({ label: 'Select Client', value: '' });
	const [paymentData, setPaymentData] = useState<PaymentData>(initialPaymentData);
	const [projectAmount, setProjectAmount] = useState<ProjectAmount>(initialProjectAmount);
	const [selectedInvoiceRows, setSelectedInvoiceRows] = useState<InvoiceRow[]>([]);
	const [invoiceOptionsForSelect, setInvoiceOptionsForSelect] = useState<Array<{ label: string; value: number; [key: string]: any }>>([]);
	const [selectedInvoicesMulti, setSelectedInvoicesMulti] = useState<Array<{ label: string; value: number; [key: string]: any }>>([]);

	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);

	useEffect(() => {

		setPaymentData(initialPaymentData);
		setProjectAmount(initialProjectAmount)
		setSalesInvoice({ label: 'Select Sales Invoice', value: '' })
		setSalesOrder({ label: 'Select Sales Order', value: '' })
		setChequeAccount({ label: 'Select Account Number', value: '' })
		setAccount({ label: 'Select Account Number', value: '' })
		setCashBox({ label: 'Select Cash Box', value: '' })
		setMobileWallet({ label: 'Select Mobile Wallet', value: '' })
		setBank({ label: 'Select Bank', value: '' })
		setSr({ label: 'Select SR', value: '' })
		setProject({ label: 'Select Project', value: '' })
		setPaymentMethod('bank_transfer')
		setPaymentType('advance')
		setMaxPayableAmount(0)
		setSelectedInvoiceRows([])
		setSelectedInvoicesMulti([])
		setInvoiceOptionsForSelect([])

		getProjects()
		getCompanies()

	}, [id]);

	useEffect(() => {

		if (paymentData.idProjects !== 0) {
			getAllSalesRepresentative(paymentData.idProjects)
			getMobileWallets(paymentData.idProjects)
			getCashBoxes(paymentData.idProjects)
			getChequeAccounts(paymentData.idProjects)
			getBanks(paymentData.idProjects)
			setBank({ label: 'Select Bank', value: '' })
			setAccount({ label: 'Select Account Number', value: '' })
			setCashBox({ label: 'Select Cash Box', value: '' })
			setMobileWallet({ label: 'Select Mobiel Wallet', value: '' })
			setChequeAccount({ label: 'Select Account Number', value: '' })
			setSr({ label: 'Select SR', value: '' })
		}

	}, [paymentData.idProjects]);

	useEffect(() => {
		if (idSalesPayments !== 0) {
			getSalesPayment(idSalesPayments);
		}
	}, [id, idSalesPayments]);

	const handleChange = (e: any) => {
		if (paymentType === 'regular' && e.target.name === 'paymentAmount') {
			if (parseFloat(e.target.value) > maxPayableAmount) {
				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: 'Max Payable Amount Exceed!',
				})
				e.target.value = '';
				return
			}
		}
		setPaymentData({ ...paymentData, [e.target.name]: e.target.value });
	};

	const handleProjectChange = (project: any) => {
		setProject(project);
		if (paymentType === 'regular') {
			setCompany({ label: 'Select Client', value: '' });
			setSelectedInvoiceRows([]);
			setSelectedInvoicesMulti([]);
			setInvoiceOptionsForSelect([]);
		} else {
			getOrdersByProjects(project.value);
		}
		setSalesOrder({ label: 'Select Sales Order', value: '' });
		setSalesInvoice({ label: 'Select Sales Invoice', value: '' });
		setPaymentData({ ...paymentData, idProjects: project.value, idCompanies: 0, idSr: 0, idSalesOrders: 0, idSalesInvoice: 0, idBanks: 0, idBankCash: 0, paymentAmount: 0 });
	}

	const getOrdersByProjects = (idProjects: number) => {
		fetch(
			process.env.REACT_APP_API_URL + 'sales-order-by-project/' + idProjects + '?type=' + paymentType,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let salesOrders = resp.data.map((item: any) => {
					item.label = 'Order # ' + item.id + '; Amount:' + item.order_amount + '; Client:' + item.company_name;
					item.value = item.id;
					return item
				})
				setSalesOrders(salesOrders);
				setProjectAmount({ ...projectAmount, invoice: parseFloat(resp.total.invoice), payment: parseFloat(resp.total.payment), shipment: parseFloat(resp.total.shipment) });
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getProjects = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'lead/projects',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let projects = resp.data.map((item: any) => {
					item.label = item.name;
					item.value = item.id;
					return item
				})
				setProjects(projects);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getCompanies = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'lead/companies',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let companiesObj = resp.data.map((item: any) => {
					item.label = item.name + ' (ID:'+item.id+')';
					item.value = item.id;
					return item
				})
				setCompanies(companiesObj);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getMaxPaymentAmount = () => {
		const payload: any = {
			paymentType: paymentType,
			idSalesOrders: paymentData.idSalesOrders || undefined,
			idSalesInvoice: paymentData.idSalesInvoice || undefined,
			idCompanies: paymentData.idCompanies || undefined,
			idProjects: paymentData.idProjects || undefined,
			idSalesPayments: idSalesPayments || undefined,
		};
		fetch(
			process.env.REACT_APP_API_URL + 'sales-payment/get-max-payable-amount',
			postRequestOptions(payload)
		)
			.then((resp) => resp.json())
			.then((resp) => setMaxPayableAmount(resp.maxPayableAmount ?? 0))
			.catch(() => setMaxPayableAmount(0));
	}

	const getChequeAccounts = (idProjects: number) => {
		fetch(
			process.env.REACT_APP_API_URL + 'chequeAccounts?idProjects=' + idProjects,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let accounts = resp.data.map((item: any) => {
					item.label = item.accountNumber;
					item.value = item.idBankCash;
					return item
				})
				setChequeAccounts(accounts);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getBanks = (idProjects: number) => {
		fetch(
			process.env.REACT_APP_API_URL + 'cashBanks?idProjects=' + idProjects,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let banks = resp.data.map((item: any) => {
					item.label = item.bankNameShort;
					item.value = item.idBanks;
					return item
				})
				setBanks(banks);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getInvoicesByClient = (idProjects: number, idCompanies: number) => {
		const exclude = idSalesPayments ? `&idSalesPayments=${idSalesPayments}` : '';
		fetch(
			`${process.env.REACT_APP_API_URL}sales-payment/invoices-by-client?idProjects=${idProjects}&idCompanies=${idCompanies}${exclude}`,
			getRequestOptions()
		)
			.then((resp) => resp.json())
			.then((resp) => {
				if (resp.success && resp.data) {
					const rows: InvoiceRow[] = resp.data.map((item: any) => ({
						id: item.id,
						idSalesOrders: item.idSalesOrders,
						invoiceId: item.invoiceId,
						invoiceAmount: item.invoiceAmount,
						alreadyPaidAmount: item.alreadyPaidAmount,
						remainingAmount: item.remainingAmount,
						adjustment: Number(item.advanceAdjustment ?? item.advance_adjustment ?? 0),
						paidAmount: item.remainingAmount,
						salesOrderId: item.salesOrderId,
					}));
					const options = rows.map((r: InvoiceRow) => ({
						label: `Invoice # ${r.invoiceId} (ID # ${r.id}) Order # ${r.salesOrderId} | Remaining: ${Number(r.remainingAmount).toFixed(2)}`,
						value: r.id,
						...r,
					}));
					setInvoiceOptionsForSelect(options);
				} else {
					setInvoiceOptionsForSelect([]);
				}
			})
			.catch(() => {
				setInvoiceOptionsForSelect([]);
			});
	}

	const getSalesInvoices = (idSalesOrders: number) => {
		fetch(
			process.env.REACT_APP_API_URL + 'sales-invoice-by-orders/' + idSalesOrders,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let invoices = resp.data.map((item: any) => {
					item.label = 'Invoice # ' + item.invoice_id + '(ID # ' + item.id + ')';
					item.value = item.id;
					return item
				})
				setSalesInvoices(invoices);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getMobileWallets = (idProjects: number) => {
		fetch(
			process.env.REACT_APP_API_URL + 'mobileWallets?idProjects=' + idProjects,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let wallets = resp.data.map((item: any) => {
					item.label = item.walletName + ' - ' + item.walletNumber;
					item.value = item.idBankCash;
					return item
				})
				setMobileWallets(wallets);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getCashBoxes = (idProjects: number) => {
		fetch(
			process.env.REACT_APP_API_URL + 'cashboxes?idProjects=' + idProjects,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let boxes = resp.data.map((item: any) => {
					item.label = item.cashBoxName + ' - ' + item.cashBoxLocation;
					item.value = item.idBankCash;
					return item
				})
				setCashBoxes(boxes);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getSalesPayment = (idSalesPayments: number) => {
		Swal.fire({
			title: 'Loading Data',
			text: 'Please wait...',
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
			showConfirmButton: false,
			willOpen: () => {
				Swal.showLoading()
			},
		})

		fetch(
			process.env.REACT_APP_API_URL + 'sales-payment/' + idSalesPayments,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {

				let salesPaymentData = resp.data
				setPaymentData(
					{
						...paymentData,
						idSalesPayments: salesPaymentData.id_sales_payments,
						idSr: salesPaymentData.id_sr,
						paymentType: salesPaymentData.paymentType,
						idSalesOrders: salesPaymentData.id_sales_orders,
						idSalesInvoice: salesPaymentData.id_sales_invoice,
						idProjects: salesPaymentData.id_projects,
						paymentMethod: salesPaymentData.paymentMethod,
						idCompanies: salesPaymentData.id_companies,
						salesType: salesPaymentData.salesType,
						idBanks: (salesPaymentData.paymentMethod === 'bank_transfer') ? salesPaymentData.bank_cash?.id_banks : 0,
						idBankCash: salesPaymentData.id_bank_cash,
						paymentAmount: Number(salesPaymentData.paymentAmount),
						remarks: salesPaymentData.remarks,
						paymentDate: salesPaymentData.paymentDate,
						transactionId: salesPaymentData.transactionId,
					}
				);

				setProject({ label: salesPaymentData.project?.projectName, value: salesPaymentData.id_projects })
				setPaymentType(salesPaymentData.paymentType);
				setPaymentMethod(salesPaymentData.paymentMethod);

				if (salesPaymentData.paymentMethod === 'bank_transfer') {
					const bankInfo = { label: salesPaymentData.bank_cash?.bank.bankNameShort, value: salesPaymentData.bank_cash?.id_banks };
					setBank(bankInfo);
					// handleBankChange(bankInfo);
					setAccount({ label: salesPaymentData.bank_cash?.accountNumber, value: salesPaymentData.id_bank_cash });
				}

				if (salesPaymentData.paymentMethod === 'cheque') {
					setChequeAccount({ label: salesPaymentData.bank_cash?.accountNumber, value: salesPaymentData.id_bank_cash });
				}

				if (salesPaymentData.paymentMethod === 'mobile_wallet') {
					setMobileWallet({ label: salesPaymentData.bank_cash?.walletName, value: salesPaymentData.id_bank_cash });
				}

				if (salesPaymentData.paymentMethod === 'cash') {
					setCashBox({ label: salesPaymentData.bank_cash?.cashBoxName, value: salesPaymentData.id_bank_cash });
				}

				if (salesPaymentData.paymentType === 'regular') {
					const allocations = salesPaymentData.sales_payment_invoices || salesPaymentData.salesPaymentInvoices;
					if (allocations && allocations.length > 0) {
						setCompany({ label: salesPaymentData.company?.company_name || salesPaymentData.company?.companyName, value: salesPaymentData.id_companies });
						getInvoicesByClient(salesPaymentData.id_projects, salesPaymentData.id_companies);
						const rows: InvoiceRow[] = allocations.map((a: any) => {
							const inv = a.sales_invoice || a.salesInvoice || {};
							const adj = Number(inv.advanceAdjustment ?? inv.advance_adjustment ?? 0);
							return {
								id: a.id_sales_invoice,
								idSalesOrders: a.id_sales_orders,
								invoiceId: inv.invoice_id || inv.invoiceId || '',
								invoiceAmount: inv.invoice_amount || inv.invoiceAmount || 0,
								alreadyPaidAmount: Number(a.alreadyPaidAmount ?? a.already_paid_amount ?? 0),
								remainingAmount: Number(a.remainingAmount ?? a.remaining_amount ?? 0),
								adjustment: adj,
								paidAmount: Number(a.paid_amount) || 0,
								salesOrderId: a.sales_order?.sales_order_id || a.salesOrderId || '',
							};
						});
						setSelectedInvoiceRows(rows);
						setSelectedInvoicesMulti(rows.map((r: InvoiceRow) => ({ label: `Invoice # ${r.invoiceId} (ID # ${r.id}) Order # ${r.salesOrderId} | Remaining: ${Number(r.remainingAmount).toFixed(2)}`, value: r.id, ...r })));
						const totalAmount = rows.reduce((a, r) => a + (Number(r.paidAmount) || 0), 0);
						setPaymentData((prev) => ({ ...prev, idSalesOrders: 0, idSalesInvoice: 0, paymentAmount: Number(totalAmount), invoiceAllocations: rows.map((r: InvoiceRow) => ({ idSalesInvoice: r.id, idSalesOrders: r.idSalesOrders, paidAmount: Number(r.paidAmount) || 0 })) }));
					} else {
						getOrdersByProjects(salesPaymentData.id_projects);
						getSalesInvoices(salesPaymentData.id_sales_orders);
						setSalesOrder({ label: 'Order # ' + salesPaymentData.sales_order?.id_sales_orders + '; Amount:' + salesPaymentData.sales_order?.orderAmount + '; Client:' + salesPaymentData.company?.companyName, value: salesPaymentData.id_sales_orders })
						setSalesInvoice({ label: `Invoice # ${salesPaymentData.invoice?.invoiceId}(ID # ${salesPaymentData?.invoice?.id_sales_invoice}) Order # ${salesPaymentData.sales_order?.sales_order_id}`, value: salesPaymentData.id_sales_invoice });
					}
					getMaxPaymentAmount();
				}
				if (salesPaymentData.paymentType === 'advance') {
					setCompany({ label: salesPaymentData.company?.company_name || salesPaymentData.company?.companyName, value: salesPaymentData.id_companies });
					setSr({ label: (salesPaymentData.sr?.first_name || salesPaymentData.sr?.firstName) + ' ' + (salesPaymentData.sr?.last_name || salesPaymentData.sr?.lastName), value: salesPaymentData.id_sr });
					getMaxPaymentAmount();
				}
				Swal.close();

				// setBank({ label: paymentData.bankName, value: paymentData.idBanks });
				// setAccount({ label: paymentData.accountNumber, value: paymentData.idBankCash });
				// setMobileWallet({ label: paymentData.walletName, value: paymentData.idBankCash });
				// setCashBox({ label: paymentData.cashBoxName, value: paymentData.idBankCash });
				// setChequeAccount({ label: paymentData.accountNumber, value: paymentData.idBankCash });
				// setSalesOrder({ label: 'Order # ' + paymentData.idSalesOrders, value: paymentData.idSalesOrders });
				// setSalesInvoice({ label: 'Invoice # ' + paymentData.idSalesInvoice, value: paymentData.idSalesInvoice });
				// setCompany({ label: paymentData.companyName, value: paymentData.idCompanies });
				// setMaxPayableAmount(paymentData.maxPayableAmount);

			})
			.catch((error) => {
				Swal.close();
				console.log(error, 'catch the hoop')
			})
	}

	const salesPaymentSave = async (event: any) => {
		setLoading(true);
		event.preventDefault()
		setSubmitDisable(true);
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Submit it!',
		})
		if (confirm.value) {

			const postData = {
				salesPayment: paymentData,
			}
			const requestOptions = postRequestOptions(postData)
			try {
				let response = await fetch(
					`${process.env.REACT_APP_API_URL}sales-payment/update`,
					requestOptions
				)
				let respData = await response.json()
				if (respData.success === true) {

					const successMsg = respData.successMessage
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: successMsg,
					})
					handleClose(true)

				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					})
				}
				setSubmitDisable(false);
				setLoading(false);

			} catch (error) {
				setLoading(false);
				console.log(error, 'catch the hoop')
				setSubmitDisable(false);
			}
		}
	}

	const handleSalesOrderChange = (salesOrder: any) => {
		setSalesOrder(salesOrder);
		setPaymentData({ ...paymentData, idSalesOrders: salesOrder.value, idCompanies: salesOrder.id_companies });
		getSalesInvoices(salesOrder.value);
	}

	useEffect(() => {
		getMaxPaymentAmount();
	}, [paymentData.idSalesOrders, paymentData.idSalesInvoice, paymentData.idCompanies, paymentData.idProjects, paymentType]);

	const handleSalesInvoiceChange = (salesInvoice: any) => {
		setSalesInvoice(salesInvoice);
		setPaymentData({ ...paymentData, idSalesInvoice: salesInvoice.value });
	}

	const handleBankAccountChange = (account: any) => {
		setAccount(account);
		setPaymentData({ ...paymentData, idBankCash: account.value });
	}

	const handleCompanyChange = (companyVal: any) => {
		setCompany(companyVal);
		setPaymentData({ ...paymentData, idCompanies: companyVal?.value || 0 });
		if (paymentType === 'regular' && companyVal?.value && project.value) {
			setSelectedInvoiceRows([]);
			setSelectedInvoicesMulti([]);
			getInvoicesByClient(project.value, companyVal.value);
		}
	}
	const handleMultiInvoiceChange = (selected: any) => {
		setSelectedInvoicesMulti(selected || []);
		if (!selected || selected.length === 0) {
			setSelectedInvoiceRows([]);
			setPaymentData((prev) => ({ ...prev, paymentAmount: 0, invoiceAllocations: undefined }));
			return;
		}
		// Build rows from selected options so adjustment (advance_adjustment) is preserved
		const rows: InvoiceRow[] = selected.map((opt: any) => {
			const adj = Number(opt.adjustment ?? opt.advanceAdjustment ?? opt.advance_adjustment ?? 0);
			const paidAmount = Math.max(0, (opt.invoiceAmount ?? 0) - adj - (opt.alreadyPaidAmount ?? 0));
			return {
				id: opt.id,
				idSalesOrders: opt.idSalesOrders,
				invoiceId: opt.invoiceId,
				invoiceAmount: opt.invoiceAmount ?? 0,
				alreadyPaidAmount: opt.alreadyPaidAmount ?? 0,
				remainingAmount: opt.remainingAmount ?? 0,
				adjustment: adj,
				paidAmount,
				salesOrderId: opt.salesOrderId ?? opt.sales_order_id ?? '',
			};
		});
		setSelectedInvoiceRows(rows);
		const sum = rows.reduce((a, r) => a + (Number(r.paidAmount) || 0), 0);
		setPaymentData((prev) => ({
			...prev,
			paymentAmount: Number(sum),
			invoiceAllocations: rows.map((r) => ({ idSalesInvoice: r.id, idSalesOrders: r.idSalesOrders, paidAmount: Number(r.paidAmount) || 0 })),
		}));
	}
	const handleInvoiceRowPaidAmountChange = (invoiceId: number, value: number) => {
		const row = selectedInvoiceRows.find((r) => r.id === invoiceId);
		if (!row) return;
		const maxAllowed = Math.max(0, row.invoiceAmount - (row.adjustment ?? 0) - row.alreadyPaidAmount);
		if (value > maxAllowed) {
			Swal.fire({
				icon: 'error',
				title: 'Invalid Amount',
				text: `Amount to pay cannot exceed remaining amount (max: ${maxAllowed.toFixed(2)})`,
				toast: true,
				position: 'top-end',
				showConfirmButton: false,
				timer: 3000,
				timerProgressBar: true,
			});
			return;
		}
		const updated = selectedInvoiceRows.map((r) =>
			r.id === invoiceId ? { ...r, paidAmount: Number(value) } : r
		);
		setSelectedInvoiceRows(updated);
		const sum = updated.reduce((a, r) => a + (Number(r.paidAmount) || 0), 0);
		setPaymentData((prev) => ({
			...prev,
			paymentAmount: Number(sum),
			invoiceAllocations: updated.map((r) => ({ idSalesInvoice: r.id, idSalesOrders: r.idSalesOrders, paidAmount: Number(r.paidAmount) || 0 })),
		}));
	}
	const handleChequeAccountChange = (account: any) => {
		setChequeAccount(account);
		setPaymentData({ ...paymentData, idBankCash: account.value });
	}

	const handleBankChange = (bank: any) => {
		setBank(bank);
		setPaymentData({ ...paymentData, idBanks: bank.value });
		fetch(
			process.env.REACT_APP_API_URL + 'bankAccounts/' + bank.value + '?idProjects=' + paymentData.idProjects,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				setAccount({ label: 'Select Account Number', value: '' })
				let accounts = resp.data.map((item: any) => {
					item.label = item.accountNumber;
					item.value = item.idBankCash;
					return item
				})
				setAccounts(accounts);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getAllSalesRepresentative = (idProjects: number) => {

		fetch(
			process.env.REACT_APP_API_URL + 'getAllSr?idProjects=' + idProjects,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {

				let users = resp.map((item: any) => {
					item.label = item.first_name + ' ' + item.last_name;
					item.value = item.id;
					return item
				})
				setSrs(users);

			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const handlePaymentTypeChange = (e: any) => {
		const newType = e.target.value;
		setPaymentType(newType);
		setProject({ label: 'Select Project', value: '' });
		setSalesOrder({ label: 'Select Sales Order', value: '' });
		setSalesInvoice({ label: 'Select Sales Invoice', value: '' });
		setCompany({ label: 'Select Client', value: '' });
		setSelectedInvoiceRows([]);
		setSelectedInvoicesMulti([]);
		setInvoiceOptionsForSelect([]);
		setPaymentData({ ...paymentData, [e.target.name]: newType, idProjects: 0, idCompanies: 0, idSalesOrders: 0, idSalesInvoice: 0, paymentAmount: 0, invoiceAllocations: undefined });
	};

	const handleMobileWalletChange = (mobileWallet: any) => {
		setMobileWallet(mobileWallet);
		setPaymentData({ ...paymentData, idBankCash: mobileWallet.value });
	};

	const handleCashboxChange = (cashBox: any) => {
		setCashBox(cashBox);
		setPaymentData({ ...paymentData, idBankCash: cashBox.value });
	};

	const handleSelectOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		setPaymentData({ ...paymentData, [event.target.id]: event.target.value });
		setPaymentMethod(event.target.value)
	};

	const handleSrChange = (sr: any) => {
		setSr(sr);
		setPaymentData({ ...paymentData, idSr: sr.value });
	}

	return (
		<Modal show={show} onHide={() => handleClose(false)} size="xl">
			<form onSubmit={salesPaymentSave}>
				<Modal.Header closeButton>
					{paymentData.idSalesOrders !== 0 &&
						<Modal.Title>Edit Sales Order Payment (Order No # {paymentData.idSalesOrders})</Modal.Title>
					}
					{paymentData.idSalesOrders === 0 &&
						<Modal.Title>Edit Sales Payment</Modal.Title>
					}
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<label htmlFor="paymentType" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Payment Type <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<label>
								<input
									name="paymentType"
									type="radio"
									value="advance"
									checked={paymentType === 'advance'}
									onChange={handlePaymentTypeChange}
								/>
								&nbsp;Advance/Bulk Payment
							</label>
							&nbsp;&nbsp;&nbsp;&nbsp;
							<label>
								<input
									name="paymentType"
									type="radio"
									value="regular"
									checked={paymentType === 'regular'}
									onChange={handlePaymentTypeChange}
								/>
								&nbsp;Regular
							</label>

						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="project" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Project <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<Select
								value={project}
								onChange={handleProjectChange}
								options={projects}
								menuPosition="fixed"
							/>
						</div>
					</div>

					{paymentType === 'regular' && (
						<>
							<div className="form-group row">
								<label className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Client <span className="required text-danger"></span></label>
								<div className="col-lg-5">
									<Select
										value={company}
										onChange={handleCompanyChange}
										options={companies}
										menuPosition="fixed"
										isClearable={true}
										placeholder="Select Client"
									/>
								</div>
							</div>
							<div className="form-group row">
								<label className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Sales Invoice(s) <span className="required text-danger"></span></label>
								<div className="col-lg-5">
									<Select
										value={selectedInvoicesMulti}
										onChange={handleMultiInvoiceChange}
										options={invoiceOptionsForSelect}
										menuPosition="fixed"
										isMulti
										placeholder="Select one or more invoices"
									/>
								</div>
							</div>
							{selectedInvoiceRows.length > 0 && (
								<div className="form-group row">
									<label className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Invoice allocation</label>
									<div className="col-lg-9">
										<div className="table-responsive">
											<table className="table table-bordered table-sm">
												<thead>
													<tr>
														<th>Invoice NO</th>
														<th>Invoice Amount</th>
														<th>Adjusted Amount</th>
														<th>Already Paid Amount</th>
														<th>Amount to pay</th>
													</tr>
												</thead>
												<tbody>
													{selectedInvoiceRows.map((row) => (
														<tr key={row.id}>
															<td>{row.invoiceId}</td>
															<td>{Number(row.invoiceAmount).toFixed(2)}</td>
															<td>{Number(row.adjustment ?? 0).toFixed(2)}</td>
															<td>{Number(row.alreadyPaidAmount).toFixed(2)}</td>
															<td>
																<input
																	type="number"
																	step="any"
																	className="form-control form-control-sm"
																	value={Number(row.paidAmount) || ''}
																	onChange={(e) => handleInvoiceRowPaidAmountChange(row.id, Number(e.target.value) || 0)}
																/>
															</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							)}
							{selectedInvoiceRows.length === 0 && (
								<>
									<div className="form-group row">
										<label className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Sales Order</label>
										<div className="col-lg-5">
											<Select value={salesOrder} onChange={handleSalesOrderChange} options={salesOrders} menuPosition="fixed" />
										</div>
									</div>
									<div className="form-group row">
										<label className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Sales Invoice</label>
										<div className="col-lg-5">
											<Select value={salesInvoice} onChange={handleSalesInvoiceChange} options={salesInvoices} menuPosition="fixed" />
										</div>
									</div>
								</>
							)}
						</>
					)}

					{paymentType === 'advance' && (
						<>
							<div className="form-group row">
								<label className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Client <span className="required text-danger"></span></label>
								<div className="col-lg-5">
									<Select
										value={company}
										onChange={handleCompanyChange}
										options={companies}
										menuPosition="fixed"
										isClearable={true}
										placeholder="Select Client"
									/>
								</div>
							</div>
							<div className="form-group row">
								<label className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select SR</label>
								<div className="col-lg-5">
									<Select
										value={sr}
										onChange={handleSrChange}
										options={srs}
										menuPosition="fixed"
										isClearable={true}
									/>
								</div>
							</div>
							<div className="form-group row">
								<label className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Sales Type</label>
								<div className="col-lg-5">
									<label>
										<input name="salesType" type="radio" value="Inter Business Unit" onChange={handleChange} checked={paymentData.salesType === 'Inter Business Unit'} />
										&nbsp;Inter Business Unit
									</label>
									&nbsp;&nbsp;&nbsp;&nbsp;
									<label>
										<input name="salesType" type="radio" value="Corporate" onChange={handleChange} checked={paymentData.salesType === 'Corporate'} />
										&nbsp;Corporate
									</label>
								</div>
							</div>
						</>
					)}
					<div className="form-group row">
						<label htmlFor="idCompanyProjects" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Payment Method <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<select name='paymentMethod' id="paymentMethod" onChange={handleSelectOnChange} className="form-control form-control-sm">
								<option value={'bank_transfer'}>Bank Transfer</option>
								<option value={'cash'}>Cash</option>
								<option value={'cheque'}>Cheque</option>
								<option value={'mobile_wallet'}>Mobile Wallet</option>
							</select>
						</div>
					</div>
					{paymentMethod === 'bank_transfer' &&
						<>
							<div className="form-group row">
								<label htmlFor="idBanks" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Transfer From Bank <span className="required text-danger"></span></label>
								<div className="col-lg-5">
									<Select
										value={bank}
										onChange={handleBankChange}
										options={banks}
										menuPosition="fixed"
									/>
								</div>
							</div>
							<div className="form-group row">
								<label htmlFor="idBanks" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Deposit Account Number <span className="required text-danger"></span></label>
								<div className="col-lg-5">
									<Select
										value={account}
										onChange={handleBankAccountChange}
										options={accounts}
										menuPosition="fixed"
									/>
								</div>
							</div>
						</>
					}

					{paymentMethod === 'cheque' &&
						<div className="form-group row">
							<label htmlFor="idBanks" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Account Number <span className="required text-danger"></span></label>
							<div className="col-lg-5">
								<Select
									value={chequeAccount}
									onChange={handleChequeAccountChange}
									options={chequeAccounts}
									menuPosition="fixed"
								/>
							</div>
						</div>
					}

					{paymentMethod === 'mobile_wallet' &&
						<div className="form-group row">
							<label htmlFor="idMobileWallet" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Mobile Wallet <span className="required text-danger"></span></label>
							<div className="col-lg-5">
								<Select
									value={mobileWallet}
									onChange={handleMobileWalletChange}
									options={mobileWallets}
									menuPosition="fixed"
								/>
							</div>
						</div>
					}

					{paymentMethod === 'cash' &&
						<div className="form-group row">
							<label htmlFor="idCashBoxes" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Cash Box <span className="required text-danger"></span></label>
							<div className="col-lg-5">
								<Select
									value={cashBox}
									onChange={handleCashboxChange}
									options={cashBoxes}
									menuPosition="fixed"
								/>
							</div>
						</div>
					}

					<div className="form-group row">
						<label htmlFor="paymentDate" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Payment Date <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<input type="date" name="paymentDate" id="paymentDate" value={paymentData.paymentDate} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="paymentAmount" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Payment Amount <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							{paymentType === 'regular' && selectedInvoiceRows.length > 0 ? (
								<>
									<input type="number" name="paymentAmount" step="any" id="paymentAmount" value={paymentData.paymentAmount} readOnly className="form-control form-control-sm bg-light" />
									<small className="text-muted">Sum of amounts (editable per row above)</small>
								</>
							) : (
								<>
									<input type="number" name="paymentAmount" step="any" id="paymentAmount" value={Number(paymentData.paymentAmount) || ''} onChange={handleChange} className="form-control form-control-sm" />
								</>
							)}
						</div>
					</div>

					{paymentMethod !== 'cash' &&
						<div className="form-group row">
							<label htmlFor="transactionId" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Transaction ID <span className="required text-danger"></span></label>
							<div className="col-lg-5">
								<input type="text" name="transactionId" id="transactionId" value={paymentData.transactionId} onChange={handleChange} className="form-control form-control-sm" />
							</div>
						</div>
					}

					<div className="form-group row">
						<label htmlFor="remarks" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Remarks</label>
						<div className="col-lg-5">
							<textarea rows={4} name="remarks" id="remarks" onChange={handleChange} className="form-control form-control-sm"></textarea>
						</div>
					</div>


					{/* <pre>{JSON.stringify(paymentData, null, 2)}</pre> */}
					{/* <pre>idSalesPayments : {idSalesPayments}</pre> */}

				</Modal.Body>
				<Modal.Footer>

					<button type="submit" disabled={isSubmitDisable} className="btn btn-sm btn-primary me-2">
						{loading &&
							<Spinner
								as="span"
								animation="grow"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						}
						<span>  Submit</span>
					</button>
					<Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal >
	)
}

export default SalesPaymentEdit
